import { Navigate, useLocation } from "react-router-dom";
import { useAuth, canDo } from "@/context/AuthContext";

export default function PrivateRoute({ children, minRole = "accountant" }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) return <div className="p-10 text-slate-500 text-sm">Checking session…</div>;
    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
    if (!canDo(user, minRole)) {
        return (
            <div className="p-10 max-w-lg mx-auto" data-testid="forbidden">
                <div className="hdb-card p-6 border-l-4 border-red-500">
                    <h2 className="hdb-heading font-bold text-lg text-red-900 mb-1">Access denied</h2>
                    <p className="text-sm text-slate-600">
                        This page requires <b>{minRole.replace("_", " ")}</b> role or higher. You are signed in as <b>{user.role.replace("_", " ")}</b>.
                    </p>
                </div>
            </div>
        );
    }
    return children;
}
